import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
import { ToastV2Service } from '../services/toast-v2.service';

@Injectable({
  providedIn: 'root'
})
export class FreemiumGuard {

  constructor(
    private subscriptionService: SubscriptionService,
    private router: Router,
    private toastService: ToastV2Service
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr || userStr === 'null') {
        return this.router.createUrlTree(['/login']);
      }

      const user = JSON.parse(userStr);
      const email = user?.email;
      if (!email) {
        this.toastService.callErrorToast('Unable to verify subscription status');
        return this.router.createUrlTree(['/dashboard']);
      }

      const subscription = await this.subscriptionService.getSubscriptionStatus();
      if (!subscription) {
        this.toastService.callErrorToast('Unable to verify subscription status');
        return this.router.createUrlTree(['/dashboard']);
      }

      if (subscription.status.toLowerCase() === 'active') return true;

      this.toastService.callErrorToast('This feature requires an active subscription. Please upgrade your plan.');
      return this.router.createUrlTree(['/dashboard']);
    } catch (error) {
      this.toastService.callErrorToast('Unable to verify subscription status');
      return this.router.createUrlTree(['/dashboard']);
    }
  }
}
